module.exports = __webpack_public_path__ + "static/img/Israel-Leota.d81064a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Israel-Leota.jpg
// module id = w7WQ
// module chunks = 0